import React, { useState, useRef, useEffect } from 'react';
import './Involvement.css';

const Involvements = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const contentRefs = useRef([]);

  const involvements = [
    {
      title: 'Varsity Tennis Team – Western University',
      subtitle: '2022 – 2023',
      bullets: [
        'Competed at a high level while having the abiltiy to manage a demanding academic schedule',
        'Honed strategic thinking, adaptability, and performance under pressure',
        'Strengthened discipline, focus, and team collaboration',
      ],
    },
    {
      title: 'Student Club Involvement – Western University',
      subtitle: 'Multiple Clubs, 2024 – 2025',
      bullets: [
        'Participated in three student clubs to broaden perspectives and engage with diverse peers',
        'Took initiative to grow beyond comfort zone and contribute meaningfully to student life',
        'Gained confidence, interpersonal skills, and appreciation for collaboration across disciplines',
        'Clubs: Sports Business Club, Society of Serbian Students, Balkan Club'
      ],
    },
  ];

  const toggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
      <main className="involvements" id="involvement">
        <h1 className="title">Leadership & Involvement</h1>

        {involvements.map(({ title, subtitle, bullets }, i) => {
          const isOpen = expandedIndex === i;
          return (
            <section
              key={i}
              className={`card ${isOpen ? 'open' : ''}`}
              aria-expanded={isOpen}
              tabIndex={0}
              onClick={() => toggle(i)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  toggle(i);
                }
              }}
            >
              <header className="card-header">
                <div>
                  <h2>{title}</h2>
                  <span className="subtitle">{subtitle}</span>
                </div>

                <button
                  aria-label={isOpen ? 'Collapse details' : 'Expand details'}
                  className={`toggle-btn ${isOpen ? 'rotated' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggle(i);
                  }}
                >
                  ▼
                </button>
              </header>

              <div
                className="content-wrapper"
                ref={(el) => (contentRefs.current[i] = el)}
                style={
                  isOpen
                    ? { maxHeight: contentRefs.current[i]?.scrollHeight + 'px' }
                    : { maxHeight: '0px' }
                }
              >
                <ul className="details">
                  {bullets.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </section>
          );
        })}
      </main>
  );
};

export default Involvements;

